import PropTypes from 'prop-types';
import React from 'react';
import { Button, Card } from 'semantic-ui-react';
import styles from './EventList.scss';
import globalStyles from '../../globals.scss';
import moment from 'moment-timezone';
import { Link } from 'found';
import { GlobalNotifications, Intent } from '../../Modules';
import { commitMutation, graphql } from 'react-relay';
import styleVariables from '../../variables';
import DateUtils from '../../../lib/utils/date';

export default class EventCard extends React.Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    basic: PropTypes.bool,
    link: PropTypes.bool,
    location: PropTypes.object,
    sortable: PropTypes.bool,
    timeZone: PropTypes.string,
    listSize: PropTypes.number,
    menu: PropTypes.node,
    relay: PropTypes.object,
    showDateLabel: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: false
    };
    this.onSelect = this.onSelect.bind(this);
    this.onDeselect = this.onDeselect.bind(this);
    this.getBorderClass = this.getBorderClass.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillMount() {
    this.updateWindowDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  onSelect() {
    this.setState({ selected: true });
  }

  onDeselect() {
    this.setState({ selected: false });
  }

  getBorderClass(status) {
    switch (status) {
      case 'BOOKED':
        return styles.cardBorderPrimary;
      case 'INITIAL':
        return styles.cardBorderTentative;
      case 'CANCELED':
        return styles.cardBorderCanceled;
      default:
        return null;
    }
  }

  updateWindowDimensions() {
    this.setState({
      window: { width: window.innerWidth, height: window.innerHeight }
    });
  }

  toggleVisibility(e) {
    e.preventDefault();
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update event information',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully updated event information',
        intent: Intent.SUCCESS
      });
      this.props.relay.refetchConnection(this.props.listSize);
    };

    const mutation = graphql`
      mutation EventCard_UpdateUserEventMutation(
        $input: UpdateUserEventInput!
      ) {
        updateUserEvent(input: $input) {
          user_event {
            id
            start_at
            end_at
            booking_status
            event {
              id
              title
              start_at
              end_at
            }
            visibility
          }
        }
      }
    `;

    const id = this.props.event.id;
    const visibility =
      this.props.event.visibility === 'SHOW' ? 'HIDDEN' : 'SHOW';
    const optimisticResponse = {
      updateUserEvent: { user_event: { id, visibility } }
    };
    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id,
          visibility
        }
      },
      optimisticResponse,
      onCompleted,
      onError
    });
  }

  render() {
    const event = this.props.event;
    const timeZone = this.props.timeZone || moment.tz.guess();
    const room =
      event.user_event_segments.edges[0] &&
      event.user_event_segments.edges[0].node.room;
    const venueName =
      event.user_event_segments.edges[0] &&
      event.user_event_segments.edges[0].node.location;
    const allDay = event.start_at && event.start_at.length === 10;
    const startAt = event.start_at
      ? DateUtils.isoStringToMoment(event.start_at, allDay, timeZone)
      : null;
    const endAt = event.end_at
      ? DateUtils.isoStringToMoment(event.end_at, allDay, timeZone)
      : null;
    const hasDates = startAt && endAt;
    const multiDay = hasDates && !(startAt.isSame(endAt, 'day') ||
      (!allDay && startAt.isSame(moment(endAt).subtract(6, 'hours'), 'day')));

    const { basic, link, showDateLabel, sortable } = this.props;

    return (
      <div style={{ paddingBottom: '0.75em' }}>
        <Card
          fluid
          onMouseEnter={this.onSelect}
          onMouseLeave={this.onDeselect}
          as={link ? Link : 'div'}
          to={`/events/${event.event.id}`}
          link={link}
          style={sortable ? { cursor: 'move' } : {}}
        >
          <span />
          <div className={this.getBorderClass(event.booking_status)} />
          {(this.state.selected || this.state.window.width < styleVariables.desktopBreakpoint) && this.props.menu}
          <Card.Content
            style={{
              marginLeft: '6px',
              display: 'table',
              border: 'none',
              minHeight: '6.4rem'
            }}
          >
            <div
              style={{
                textAlign: 'center',
                paddingRight: '1em',
                minWidth: showDateLabel ? '3.5em' : '1em',
                display: 'table-cell',
                verticalAlign: 'middle'
              }}
            >
              {showDateLabel &&
                <div>
                  <p className={styles.cardDateLabel}>
                    {startAt && startAt.format('ddd')}
                    <br />
                    {startAt && startAt.format('D')}
                    <br />
                  </p>
                  {multiDay &&
                    <p className={styles.cardDateLabel}>
                      {endAt && endAt.format('ddd')}
                      <br />
                      {endAt && endAt.format('D')}
                      <br />
                    </p>}
                </div>}
            </div>
            <div
              style={{
                display: 'table-cell',
                verticalAlign: 'middle',
                width: '100%'
              }}
            >
              {!link &&
                <Link to={`/events/${event.event.id}`}>
                  <h4 style={{ display: 'inline-block', marginBottom: 0 }}>
                    {event.event.title}
                  </h4>
                </Link>}
              {link &&
                <h4 style={{ display: 'inline-block', marginBottom: 0 }}>
                  {event.event.title}
                </h4>}
              <br />
              <Card.Meta style={{ display: 'inline-block' }}>
                {venueName || 'Venue TBD'}
                {room ? ` (${room})` : ''}
                {!showDateLabel &&
                  startAt &&
                  endAt &&
                  <span>
                    <br />
                    {`${startAt.format('LL')}${multiDay
                      ? ` - ${endAt.format('LL')}`
                      : ''}`}
                  </span>}
              </Card.Meta>
            </div>
            {!basic &&
              <div
                style={{ display: 'table-cell', verticalAlign: 'middle' }}
                className={globalStyles.desktop}
              >
                {this.state.selected &&
                  <Button basic size='tiny' onClick={this.toggleVisibility}>
                    {event.visibility === 'SHOW' ? 'Archive' : 'Unarchive'}
                  </Button>}
              </div>}
          </Card.Content>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/List/EventCard.js